import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import AuctionReviewModal from './AuctionReviewModal';

// 경매 거래 후기 목록 — sold 상태에서 AuctionDetail 내 섹션으로 표시
function AuctionReviewList(props){
  var auction=props.auction;
  var auctionId=auction&&auction.id;
  var canWrite=!!props.canWrite; // 당사자만 true
  var onReviewSubmitted=props.onReviewSubmitted;

  var[reviews,setReviews]=useState([]);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');
  var[showModal,setShowModal]=useState(false);

  var loadReviews=function(){
    setLoading(true);
    setError('');
    authFetch(API+'/auctions/'+auctionId+'/reviews')
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          setReviews(d.data.reviews||[]);
        }else{
          setError((d&&d.error)||'후기 조회 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setLoading(false)});
  };

  useEffect(function(){
    loadReviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auctionId]);

  var handleSuccess=function(){
    setShowModal(false);
    loadReviews();
    if(onReviewSubmitted)onReviewSubmitted();
  };

  var myReviewExists=reviews.some(function(r){return r.isMyReview});
  var canShowWriteBtn=canWrite&&!myReviewExists;

  var starRow=function(score){
    var stars='';
    for(var i=0;i<5;i++)stars+=(i<score?'★':'☆');
    return stars;
  };

  var roleLabel=function(role){
    return role==='seller'?'출품자 후기':role==='buyer'?'낙찰자 후기':'후기';
  };

  var formatDate=function(s){
    if(!s)return '';
    try{return String(s).slice(0,10).replace(/-/g,'.')}catch(e){return ''}
  };

  return (
    <div style={{padding:'14px 20px',background:'#fff',borderTop:'1px solid #f1f5f9'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
        <div style={{fontSize:12,fontWeight:700,color:'#64748b'}}>거래 후기 {reviews.length>0&&'('+reviews.length+')'}</div>
        {canShowWriteBtn&&(
          <button onClick={function(){setShowModal(true)}}
            style={{padding:'6px 14px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:11,fontWeight:700,cursor:'pointer'}}>
            ⭐ 후기 작성하기
          </button>
        )}
      </div>

      {loading&&(
        <div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:12}}>불러오는 중...</div>
      )}

      {error&&!loading&&(
        <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:6,fontSize:11,color:'#dc2626'}}>
          ⚠ {error}
        </div>
      )}

      {!loading&&!error&&reviews.length===0&&(
        <div style={{padding:'24px 20px',textAlign:'center',background:'#f8fafc',borderRadius:8,fontSize:12,color:'#94a3b8'}}>
          아직 후기가 없습니다
          {canShowWriteBtn&&<div style={{fontSize:11,marginTop:4}}>첫 후기를 남겨보세요!</div>}
        </div>
      )}

      {!loading&&reviews.length>0&&(
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {reviews.map(function(r){
            var isBuyer=r.role==='buyer';
            return (
              <div key={r.id} style={{padding:'12px 14px',background:'#f8fafc',border:'1px solid #e5e7eb',borderRadius:8}}>
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:6}}>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <span style={{fontSize:16,color:'#F59E0B',letterSpacing:1}}>{starRow(r.score)}</span>
                    <span style={{fontSize:11,fontWeight:700,color:'#475569'}}>{r.score}.0</span>
                    <span style={{padding:'2px 8px',background:isBuyer?'#dbeafe':'#fef3c7',color:isBuyer?'#1e40af':'#92400e',borderRadius:4,fontSize:10,fontWeight:700}}>
                      {roleLabel(r.role)}
                    </span>
                    {r.isMyReview&&(
                      <span style={{padding:'2px 8px',background:'#d1fae5',color:'#047857',borderRadius:4,fontSize:10,fontWeight:700}}>내 후기</span>
                    )}
                  </div>
                  <div style={{fontSize:10,color:'#94a3b8'}}>{formatDate(r.createdAt)}</div>
                </div>
                {r.comment&&(
                  <div style={{fontSize:12,color:'#334155',lineHeight:1.6,marginTop:4,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
                    {r.comment}
                  </div>
                )}
                <div style={{fontSize:10,color:'#94a3b8',marginTop:4}}>— {r.reviewerName||'익명'}</div>
              </div>
            );
          })}
        </div>
      )}

      {showModal&&(
        <AuctionReviewModal auction={auction}
          onClose={function(){setShowModal(false)}}
          onSuccess={handleSuccess}/>
      )}
    </div>
  );
}

export default AuctionReviewList;
